module.exports = __webpack_public_path__ + "static/mockup-c3e73182c1e7d5c292992c88986ecb74.png";